import React from 'react';
import VideoModal from './VideoModal';

const ActivityCard = ({ activity = {}, onAdd }) => {
  const [showVideo, setShowVideo] = React.useState(false);

  if (!activity || typeof activity !== 'object') {
    console.error('Invalid activity prop:', activity);
    return null;
  }

  const {
    id,
    name = activity.ActivityName || 'Untitled Activity',
    skillTags = Array.isArray(activity.SkillTags) 
      ? activity.SkillTags 
      : typeof activity.SkillTags === 'string'
        ? activity.SkillTags.split(',').map(tag => tag.trim())
        : [],
    instructions = activity.Instructions || 'No instructions provided',
    videoUrl = activity.VideoURL || activity.videoUrl
  } = activity;

  return (
    <div className="bg-white rounded-lg shadow-md p-4 h-[280px] flex flex-col">
      <div className="flex-1 min-h-0">
        <h3 className="text-lg font-semibold mb-2 line-clamp-1">
          {name}
        </h3>
        {skillTags.length > 0 && (
          <div className="flex flex-wrap gap-1 mb-2">
            {skillTags.map((tag, index) => (
              <span
                key={index}
                className="bg-blue-100 text-blue-800 text-xs font-medium px-2.5 py-0.5 rounded"
              >
                {tag}
              </span>
            ))}
          </div>
        )}
        <p className="text-gray-600 line-clamp-3">
          {instructions}
        </p>
      </div>
      <div className="mt-2 space-y-2">
        {videoUrl && (
          <button
            onClick={() => setShowVideo(true)}
            className="text-blue-600 hover:text-blue-800 flex items-center gap-1"
            title={videoUrl}
          >
            <svg
              className="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
              />
            </svg>
            Watch Video
          </button>
        )}
        <button
          onClick={() => onAdd(activity)}
          className="w-full bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
        >
          Add to Session
        </button>
      </div>
      {showVideo && videoUrl && (
        <VideoModal
          videoUrl={videoUrl}
          onClose={() => setShowVideo(false)}
        />
      )}
    </div>
  );
};

export default ActivityCard; 